import _get from 'lodash/get';

import { SERVICES_SETTING } from '../../AccountSettings.constants';
import GenericEnableSettings from '../GenericEnableSettings';
import ServicesEnableSettings from '../ServicesEnableSettings';

const SYNC_NAME_TO_SETTINGS_COMPONENT = {
  [SERVICES_SETTING]: ServicesEnableSettings,
};

export function getComponentForSetting(name) {
  return _get(SYNC_NAME_TO_SETTINGS_COMPONENT, name, GenericEnableSettings);
}
